import classNames from 'classnames';
import React, { FC } from 'react';
import styles from './Heading.module.scss';

export interface IHeading {
  icon?: string;
  className?: string;
  noTopPadding?: boolean;
}

const Heading: FC<IHeading> = (props) => {
  const { icon, className, children, noTopPadding } = props;
  const rootClassName = classNames(styles.root, className, {
    [styles['no-top-padding']]: noTopPadding,
    [styles['no-text-margin']]: !icon,
  });

  return (
    <div className={rootClassName}>
      {icon && <span className={`fas fa-${icon} ${styles.icon}`} />}
      <h2 className={styles.header}>{children}</h2>
    </div>
  );
};

export default Heading;
